import React from 'react';
import { ProviderTable } from './ProvidersTable';

export const ProviderList: React.FC = () => {
  return <ProviderTable />;
};
